import get from 'lodash/get.js';
import has from 'lodash/has.js';
import merge from 'lodash/merge.js';

import axios from '@/plugins/axios.js';
import Collection from '@/store/quill/Collection.js';

export default function ({ name, item }) {
    return merge(Collection(name, item), {
        actions: {
            fetch: async (context, { route, type, id, query, append }) => {
                try {
                    let api = context.state.api[route];

                    if (type === 'single') {
                        api += `/${id}`;
                    }

                    if (query) {
                        api += query;
                    }

                    if (append) {
                        api += append;
                    }

                    const { data } = await axios.get(api);

                    if (route === 'quizzes') {
                        if (has(data.meta, 'current_version') && get(data.meta, 'current_version')) {
                            data.data.quiz_version_number = data.meta.current_version.version_number;
                            data.data.quiz_version_id = data.meta.current_version.versionable_id;
                        }
                    }

                    return data.data;
                } catch (_error) {}
            },
        },
    });
}
